import { Injectable } from "@angular/core";
import { CognitoService } from "./cognito.service";
import { CanActivate } from "@angular/router";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ChangelogService } from '../changelog/changelog.service';
import { ChangelogComponent } from 'src/app/dialogs/changelog/changelog.component';

@Injectable()
export class CognitoGuardService implements CanActivate {

  constructor(
    private cognitoService: CognitoService,
    private changelogService: ChangelogService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    await this.cognitoService.ensureSessionLoaded();

    if (this.cognitoService.isAuthenticated) {
      if (state.url.startsWith('/home')) {
        this.router.navigate(["/pages/research"]);
      }

      if (!state.url.startsWith('/home')) {
        this.changelogService.canBeShown().subscribe(
          result => {
            if (result) {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.autoFocus = true;
              dialogConfig.disableClose = false;
              dialogConfig.width = "85%";
              dialogConfig.position = { top: '5%' };
              // Show the changelog
              this.dialog.open(ChangelogComponent, dialogConfig);
              return true;
            }
          },
          error => {
            console.error(error);
            return false;
          }
        );
      }
    } else {
      this.cognitoService.handleFetchAuthSession();
      return false;
    }
  }
}
